import { render } from "./H2.vue?vue&type=template&id=1fba4776"
import script from "./H2.vue?vue&type=script&lang=js"
export * from "./H2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__